import { memo } from 'react';
import { Divider, LinearProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNxtImport } from '../NxtImportContext';
import { importProgressSx } from './ImportFieldInputStyles';

const ImportStatusTooltip = memo(() => {
  const { t } = useTranslation();
  const { hasActiveImports, hasImportErrors } = useNxtImport();

  return (
    <>
      {hasActiveImports && (
        <>
          <Divider />
          <span>{t('blox.batch_import.importing_assets', 'Importing asset(s)')}</span>
          <LinearProgress sx={importProgressSx} />
        </>
      )}

      {hasImportErrors && (
        <>
          <Divider />
          <span>
            {t('blox.batch_import.import_problems', 'Problem(s) with an import')}
          </span>
        </>
      )}
    </>
  );
});

ImportStatusTooltip.displayName = 'ImportStatusTooltip';
export default ImportStatusTooltip;
